import { api } from "@/core/api";

/** Response from the view-as start/stop endpoints. */
export interface ViewAsResponse {
  success: boolean;
  /** Path to land on after the identity swap (always the personal home). */
  redirect: string;
  email?: string;
  userId?: number;
  message?: string;
}

/** Admin read-only "view-as" (impersonation) sessions (#2470).
 *
 * Starting or stopping a session swaps the browser's auth cookie to a different
 * identity, so callers should follow with a full page reload (see the auth store
 * actions) rather than trying to reconcile in-flight Pinia state.
 */
export const viewAsService = {
  /** Begin viewing as the given user (admin only). */
  async start(userId: number): Promise<ViewAsResponse> {
    return api.post<ViewAsResponse>(`/api/admin/view-as/${userId}`);
  },

  /** End the current view-as session and restore the admin identity. */
  async stop(): Promise<ViewAsResponse> {
    return api.post<ViewAsResponse>("/api/view-as/stop");
  },
};
